import { apiUrl, getToken } from '../api';

/**
 * Nahratie balíka s novou verziou (.557) – spoločné pre Nastavenia →
 * Aktualizácia aj rýchle tlačidlo v ľavom paneli.
 *
 * Server posiela priebeh po riadkoch (JSON na riadok). Vracia `true`, keď
 * aktualizácia prebehla, `false` pri chybe hlásenej v priebehu; chybu pred
 * nahrávaním (plný disk, zlá prípona) vyhodí.
 */
export async function posliAktualizaciu(file, { onLog = () => {}, onError = () => {}, onDone = () => {} } = {}) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await fetch(apiUrl('/api/update'), {
    method: 'POST',
    headers: { Authorization: `Bearer ${getToken()}` },
    body: fd,
  });
  /* Odmietnutie ešte pred nahrávaním (napr. plný disk) chodí ako obyčajný
     JSON, nie ako prúd riadkov. */
  if (!res.ok) {
    let sprava = `Chyba ${res.status}`;
    try {
      const telo = await res.clone().json();
      if (telo?.error) sprava = telo.error;
    } catch { /* nebol to JSON – ostane číslo chyby */ }
    throw new Error(sprava);
  }
  if (!res.body) throw new Error('Server neposlal odpoveď.');

  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = '';
  let failed = false;
  let hotovo = false;
  /* Posledný riadok nemusí končiť zalomením – spracuje sa aj on. */
  const spracuj = (parts) => {
    for (const part of parts) {
      if (!part.trim()) continue;
      let msg;
      try { msg = JSON.parse(part); } catch { continue; }
      if (msg.log) onLog(msg.log);
      if (msg.error) { failed = true; onError(msg.error); }
      if (msg.done) { hotovo = true; onDone(msg.message); }
    }
  };
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split('\n');
    buf = parts.pop() || '';
    spracuj(parts);
  }
  spracuj([buf]);
  return hotovo && !failed;
}
